<template>
  <div>
    <transition name="van-slide-down">
      <van-cell-group title="核销流程" :border="true">
        <van-steps :active="1">
          <van-step>购买核销套盒</van-step>
          <van-step>进店消费</van-step>
          <van-step>出示核销码</van-step>
          <van-step>服务完成</van-step>
        </van-steps>
      </van-cell-group>
    </transition>

    <van-sticky>
      <van-tabs v-model="active" @click="tabChange">
        <van-tab title="待核销套盒"></van-tab>
        <van-tab title="核销完成套盒"></van-tab>
        <van-tab title="门店地址"></van-tab>
      </van-tabs>
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      v-if="active != 2"
    >
      <div style="margin-top: 0.3rem;"></div>
      <div class="product" v-for="(item, index) of list" :key="index">
        <div class="ub">
          <van-image
            width="100"
            height="100"
            :src="item.product_info.img + '!content'"
            class="main-img"
          />
          <div class="uf1">
            <div class="title">{{ item.product_info.title || "" }}</div>
            <div class="ub desc">
              <div class="left uf1">
                <div>已用：{{ item.use_numbers }} / {{ item.numbers }}</div>
                <div>规格：{{ item.product_info.spec || "" }}</div>
              </div>
              <van-circle
                v-model="item.rate"
                :rate="item.rate"
                size="70px"
                layer-color="#ebedf0"
                :speed="100"
                :text="item.rate + '%'"
              />
            </div>
          </div>
        </div>
        <div class="ub ubh-e foot van-hairline--top">
          <van-button
            size="small"
            type="primary"
            class="hxm"
            @click="createQrcode(item)"
            >生成核销码</van-button
          >
          <van-button size="small" @click="showLog(item)">核销记录</van-button>
        </div>
      </div>
    </van-list>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      v-else-if="active == 2"
    >
      <div style="margin-top: 0.3rem;"></div>
      <div class="product" v-for="(item, index) of shopList" :key="index">
        <div class="ub">
          <div class="uf1">
            <div class="title">{{ item.title || "" }}</div>
            <div class="ub desc">
              <div class="left uf1">
                <div>地址：{{ item.address }}</div>
              </div>
            </div>
          </div>
          <a :href="'tel:' + item.tel">
            <van-button size="small" type="primary" class="hxm"
              >拨打电话</van-button
            >
          </a>
        </div>
      </div>
    </van-list>
    <van-popup v-model="showQrcode" class="hx" :round="true" position="bottom">
      <div class="title tx-c" v-if="row.product_info">
        {{ row.product_info.title || "" }}核销码
      </div>
      <div class="desc ub ubh-e">第：{{ row.use_numbers + 1 }} 次消费</div>
      <div class="tx-c rel">
        <van-image class="hx-qrcode" :src="qrCode" v-if="qrCode" />
        <van-loading v-else type="spinner" color="#1989fa" vertical
          >核销码生成中...</van-loading
        >
        <div
          class="qr-status abs ub ubv-c ubh-c"
          v-if="['TIMEOUT', 'SUCCESS'].includes(qrStatus.key)"
        >
          <div
            v-if="['TIMEOUT'].includes(qrStatus.key)"
            @click="createQrcode(row)"
          >
            <van-icon name="replay" size="40" />
            <div class="msg">二维码失效，点击刷新</div>
          </div>
          <div v-else-if="qrStatus.key == 'SUCCESS'">
            <van-icon name="certificate" size="40" />
            <div class="msg">扫码成功</div>
          </div>
        </div>
      </div>
      <van-divider dashed :hairline="true">请将二维码展示给店家</van-divider>
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        核销码扫码成功后扣一次，核销码3分钟内有效
      </van-notice-bar>
    </van-popup>
    <van-popup v-model="showLogs" class="logs" :round="true" position="bottom">
      <div v-if="!logListLoad" class="hx-log-list">
        <div class="title tx-c" v-if="row.product_info">
          {{ row.product_info.title || "" }} 核销记录({{ logList.length }})
        </div>
        <div v-if="logList.length">
          <div class="item" v-for="(item, index) of logList" :key="index">
            <div class="title">
              {{ item.shop_name }}
            </div>
            <div class="ub ub-sb">
              <div>
                核销员：<span>{{ item.clerk_name }}</span>
              </div>
              <span>
                {{ item.add_time }}
              </span>
            </div>
          </div>
        </div>
        <van-empty v-else image="search" description="暂无核销记录" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { wechatEvevt } from "@libs/wechat";
import {
  CellGroup as VanCellGroup,
  Step as VanStep,
  Steps as VanSteps,
  Sticky as VanSticky,
  List as VanList,
  Icon as VanIcon,
  // Cell as VanCell,
  Tab as VanTab,
  Tabs as VanTabs,
  Empty as VanEmpty,
  Toast,
  // Card as VanCard,
  // Tag as VanTag,
  Button as VanButton,
  Circle as VanCircle,
  Image as VanImage,
  Popup as VanPopup,
  Divider as VanDivider,
  NoticeBar as VanNoticeBar,
  Loading as VanLoading
} from "vant";
import {
  WriteOffGoodsList,
  WriteOffQrcode,
  WriteOffLog,
  checkQrStatus,
  getShopList
} from "@/api/user";
export default {
  name: "index",
  components: {
    VanCellGroup,
    VanEmpty,
    VanIcon,
    VanStep,
    VanSteps,
    VanSticky,
    VanList,
    VanLoading,
    // VanCell,
    VanTab,
    VanTabs,
    // VanCard,
    // VanTag,
    VanButton,
    VanCircle,
    VanImage,
    VanPopup,
    VanDivider,
    VanNoticeBar
  },
  data: () => {
    return {
      loading: false,
      finished: false,
      showLogs: false,
      active: 0,
      list: [],
      logList: [],
      logListLoad: false,
      currentRate: 70,
      showQrcode: false,
      row: {},
      queryParam: {
        page_size: 10,
        page: 0,
        is_all: 0
      },
      qrCode: "",
      qrStatus: {
        key: "",
        msg: ""
      },
      qrToken: "",
      shopList: [],
      location: null
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getLocation() {
      let config = {};
      return new Promise((succ, err) => {
        wechatEvevt("getLocation", config)
          .then(res => {
            console.log("getLocation-res:", res);
            let { latitude, longitude } = res;
            this.location = { lat: latitude, lng: longitude };
            succ();
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.getLocation({
                type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: res => {
                  // if (this.userInfo['id']==220) {
                  //     alert('getLocation-success:'+JSON.stringify(res))
                  // }
                  let { latitude, longitude } = res;
                  this.location = { lat: latitude, lng: longitude };
                  succ();
                },
                fail: msg => {
                  err(msg);
                }
              });
            }
          });
      });
    },
    async getShopList() {
      if (this.shopList.length) {
        return;
      }
      Toast.loading("加载中...");
      if (!this.location) {
        await this.getLocation();
      }
      let location = this.location.lat + "," + this.location.lng;
      getShopList({ location, radius: 10000 })
        .then(({ data }) => {
          this.shopList = data || [];
        })
        .finally(() => {
          Toast.clear();
        });
    },
    tabChange(name) {
      if (name > 1) {
        this.getShopList();
        return;
      }
      this.queryParam["page"] = 0;
      this.queryParam["is_all"] = name;
      this.getList();
      this.list = [];
    },
    getList() {
      if (this.loading) return;
      this.loading = true;
      Toast.loading("加载中...");
      this.queryParam["page"]++;
      WriteOffGoodsList(this.queryParam)
        .then(({ data }) => {
          if (!data || !data.length) {
            this.finished = true;
            return;
          }
          this.list.push.apply(this.list, data);
          if (data.length < this.queryParam.page_size) {
            this.finished = true;
          }
        })
        .finally(() => {
          Toast.clear();
          this.loading = false;
        });
    },
    createQrcode(item) {
      this.showQrcode = true;
      this.row = item;
      // this.qrCode = "";
      this.qrToken = "";
      WriteOffQrcode({ id: item.id })
        .then(({ data: { qrcode, token } }) => {
          this.qrCode = qrcode;
          this.qrToken = token;
          this.checkQrStatus();
        })
        .finally(() => {});
    },
    checkQrStatus() {
      if (!this.qrToken || !this.showQrcode) {
        return;
      }
      checkQrStatus({ token: this.qrToken }).then(({ data }) => {
        this.qrStatus = data;
        switch (data.key) {
          case "SUCCESS":
            this.row.use_numbers++;
            this.row.rate = Math.floor(
              (1 - this.row.use_numbers / this.row.numbers) * 100
            );
            // console.log('this.row',this.row.use_numbers , this.row.numbers,this.row.use_numbers % this.row.numbers,(1 - (this.row.use_numbers % this.row.numbers)),(1 - (this.row.use_numbers % this.row.numbers)) * 100)
            this.qrToken = "";
            break;
          case "TIMEOUT":
            this.qrToken = "";
            break;
          case "WAIT":
            setTimeout(() => {
              this.checkQrStatus();
            }, 2000);
        }
      });
    },
    showLog(item) {
      if (this.logListLoad) return;
      this.logListLoad = true;
      this.showLogs = true;
      this.row = item;
      this.logList = [];
      WriteOffLog({ order_id: item.id })
        .then(({ data }) => {
          if (!data || !data.length) {
            return;
          }
          this.logList = data;
        })
        .finally(() => {
          this.logListLoad = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  box-sizing: border-box;
  padding: 0.3rem 0.2rem;
  margin: 0.2rem;
  border-radius: 0.3rem;
  box-shadow: 5px 5px 3px #dddddd;
  background: #ffffff;
  .main-img {
    margin-right: 10px;
  }
  .title {
    font-size: 0.3rem;
    margin-bottom: 0.15rem;
  }
  .desc {
    font-size: 0.25rem;
    color: #999999;
    .left {
      line-height: 200%;
    }
  }
  .foot {
    padding-top: 0.3rem;
    margin-top: 0.3rem;
  }
  .hxm {
    margin-right: 0.3rem;
  }
}

.hx {
  .title {
    padding: 0.2rem;
    font-size: 0.35rem;
  }
  .desc {
    padding: 0 0.3rem;
    color: #999999;
    .num {
      color: red;
    }
  }
  &-qrcode {
    width: 75%;
    margin: auto;
  }
  .qr-status {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: #ffffff;
    .msg {
      margin-top: 20px;
    }
  }
}
.hx-log-list {
  box-sizing: border-box;
  padding: 15px;
  line-height: 200%;
  .item {
    padding: 20px 0;
    border-bottom: 1px solid #e1e1e1;
  }
}
</style>
